export default {
  selectors: {
    observable: '[data-comp-sticky-container-observable]',
    options: '[data-comp-sticky-container-observer-options]',
  },
};
